/**
 *
 * Login
 *
 */

import React, { useState, useEffect, useContext } from "react";
import AppContext from '../../components/AppContext/AppContext';
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import {
  Box,
  Grid,
} from "@material-ui/core";
import "./style.css";
import Carousel from 'react-material-ui-carousel'
import ContactForm from "../ContactForm";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import pecanprep1 from "../../assets/images/product/pecanprep-1.png";
import pecanprep2 from "../../assets/images/product/pecanprep-2.png";
import pecanprep3 from "../../assets/images/product/pecanprep-3.png";
import pecanprep4 from "../../assets/images/product/pecanprep-4.png";
import { gapi } from "gapi-script";

import Snackbar from '@mui/material/Snackbar';
import YouTube from "react-youtube"; // run npm i react-youtube

import MuiAlert from '@mui/material/Alert';
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const baseURL = process.env.REACT_APP_API_HOST;
const baseauthURL = process.env.REACT_APP_AUTH_HOST;

function Item(props)
{
    return (
        <>
            <Typography
              component="h2"
              variant="h4"
              color="text.primary"
              gutterBottom
              sx={{ minHeight:{md:'10vh', sm:'12vh', xs:'15vh'}}}
            >
              {props.item.name}
            </Typography>
            {/* <br /> */}
            {/* <Typography
              component="h3"
              variant="h6"
              color="text.secondary"
              gutterBottom
            >
              {props.item.description}
            </Typography> */}

        </>
    )
}

export function Home() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const myContext = useContext(AppContext);
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [error, setError] = useState(false)
  const [contactOpen, setContactOpen] = useState(false);
  const [formValues, setFormValues] = useState({
    run_name: {
      value: '',
      error: false,
      errorMessage: 'You must enter a run name'
    },
    source_url: {
      value: '',
      error: false,
      errorMessage: 'You must enter a source url'
    }
  })
  const [selectedImage, setSelectedImage] = useState(pecanprep1)

  const [alert, setAlert] = React.useState({ 'open': false, 'message': '' });
  var items = [
    {
      name: '“Interactive Data Preparation Tool"',
      description: "Easily visualize, cleanse, and transform your data with our interactive, guided wizard"
    },
    {
        name: '“AI Powered Anomaly Detection & Outlier Identification”',
        description: "Our AI-powered analysis tools help you discover patterns and surface outliers to better understand your data"
    },
    {
      name: '“No-Code Data Cleansing & Transformation”',
      description: "Say goodbye to manual data cleansing and transformation with our no-code, wizard-driven approach"
  },
    {
      name: '“Feature Engineering for Better Signal to Noise”',
      description: "Maximize the Power of Your AI Models with  PecanPrep's Advanced Feature Engineering"
  }
]

  const opts = {
    height: "250",
    width: "350",
    playerVars: {
      autoplay: 0,
    },
  };

  const _onReady = (event) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }
  const _onEnd = (event) => {
    // access to player in all event handlers via event.target
    console.log("video ended")
    event.target.playVideo();
    event.target.pauseVideo();
  }


  useEffect(() => {
    if (myContext.signed_in !== true) {
      function start() {
        gapi.client.init({
          clientId:
            "979819894352-1msptmrk39g3ku53sgetfdvch6i6endr.apps.googleusercontent.com",
          scope: "",
        });
      }
      gapi.load("client: auth2", start);
    }
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlert({ 'open': false, 'message': '' });
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   console.log(name, value)
  //   setFormValues({
  //     ...formValues,
  //     [name]: {
  //       ...formValues[name],
  //       value
  //     }
  //   })
  // }

  // const runValidations = () => {
  //   const formFields = Object.keys(formValues);
  //   let newFormValues = { ...formValues }
  //   console.log(formFields, newFormValues)
  //   var error_count = 0
  //   for (let index = 0; index < formFields.length; index++) {
  //     const currentField = formFields[index];
  //     const currentValue = formValues[currentField].value;

  //     if (currentValue === '') {
  //       newFormValues = {
  //         ...newFormValues,
  //         [currentField]: {
  //           ...newFormValues[currentField],
  //           error: true
  //         }
  //       }
  //       error_count++
  //     } else {
  //       newFormValues = {
  //         ...newFormValues,
  //         [currentField]: {
  //           ...newFormValues[currentField],
  //           error: false
  //         }
  //       }
  //     }
  //   }
  //   console.log(newFormValues)
  //   setFormValues(newFormValues)
  //   console.log("new values has been set")
  //   return error_count
  // }

  const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  const handleShow = (title) => {
    setShow(true)
    // setPopupTitle(title)
    // setPopupDetails(serviceDetails[title])
  };


  return (
    <div>
      <Helmet>
        <title>Welcome to PecanPrep</title>
        <meta name="description" content="PecanPrep is an intelligent service, which helps you to visually explore, clean, and prepare data for analysis and machine learning." />
      </Helmet>
      {loading ? <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop> : ""}

      <Snackbar className=" mt-20" anchorOrigin={{ vertical: "top", horizontal: "center" }} open={alert.open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={alert.severity} sx={{ width: '100%' }}>
          {alert.message}
        </Alert>
      </Snackbar>
      {/* <ContactForm open={contactOpen} handleModalClose={handleContactClose} /> */}
      <Box className="py-8 mb-4">
        <Container component="main">
        <Grid container className="flex justify-between align-middle self-center items-center">
          <Grid item sm={6} xs={12}>
            {/* <Box className="flex flex-col mb-4 "> */}
              <Carousel interval={5000} sx={{ textAlign:{md:'center', xs:'center'}}}>
                {
                    items.map( (item, i) => <Item key={i} item={item} /> )
                }
            </Carousel>
            {/* </Box> */}
          </Grid>
          <Grid item md={6} className="flex-col self-center text-right ">
            <div className="flex items-center justify-end mt-8  py-[5%] pr-2">
              <YouTube videoId="OJ82NbN6yrQ" opts={opts} onReady={_onReady} onEnd={_onEnd} /></div>
          </Grid>
      </Grid>
      </Container>
      </Box>
      <hr />
      <Box className="py-8 mb- 4">
        <Container component="main">
          <Grid container spacing={0} alignItems="flex-end">
            <Grid item md={8} lg={8} sm={6} xs={12} className="self-center" style={{ marginBottom: "16px" }} >
              <Typography
                component="h2"
                variant="h5"
                color="text.primary"
                gutterBottom
              >
                Interactive Data Preparation
              </Typography>
              <p>
              PecanPrep enables users to visualize the distribution of each data point in the dataset with an appropriate graphical representation that is fit for that data type. Users can then go through a guided wizard to cleanse and transform data using various statistical strategies and visualize how the prepared data distribution would look like.
              </p>
            </Grid>
            <Grid item md={4} lg={4} sm={6} xs={12} className="cursor-pointer self-center text-center items-center" style={{ marginBottom: "16px" }}>
              <img src={pecanprep3} onClick={() => { setSelectedImage(pecanprep1); handleShow("") }} height='auto' className="center p-2" />
            </Grid>
            <Grid md={4} lg={4} sm={6} xs={12} className="cursor-pointer self-center" style={{ marginBottom: "16px" }}>
              <img src={pecanprep4} onClick={() => { setSelectedImage(pecanprep2); handleShow("") }} height='auto' className="center p-2" />
            </Grid>
            <Grid md={8} lg={8} sm={6} xs={12} className="self-center" style={{ marginBottom: "16px" }}>
              <Typography
                component="h2"
                variant="h5"
                color="text.primary"
                gutterBottom
              >
                AI Powered Data Analysis
              </Typography>
              <p>
              PecanPrep performs AI-powered data analysis to identify patterns in the dataset and surface noise in the data. An AI-powered anomaly and outlier detection system helps users understand the data better. The automatic data analysis also applies numerous statistical analysis methods for users to delve deeper into the data.
              </p>
            </Grid>
            <Grid md={8} lg={8} sm={6} xs={12} className="self-center">
              <Typography
                component="h2"
                variant="h5"
                color="text.primary"
                gutterBottom
              >
                No-Code Data Cleansing & Transformation
              </Typography>
              <p>
              PecanPrep is incredibly useful for users who need to cleanse and transform data without the assistance of developers. The guided wizard streamlines the user workflow and provides downloadable, cleansed data. Users can also download a PDF report with data distribution charts, as well as multiple data formats, all with just a few clicks and without any coding.
              </p>
            </Grid>
            <Grid md={4} lg={4} sm={6} xs={12} className="cursor-pointer self-center" style={{ marginBottom: "16px" }}>
              <img src={pecanprep1} onClick={() => { setSelectedImage(pecanprep3); handleShow("") }} height='auto' className="center p-2" />
            </Grid>
            <Grid md={4} lg={4} sm={6} xs={12} className="cursor-pointer self-center" style={{ marginBottom: "16px" }}>
              <img src={pecanprep2} onClick={() => { setSelectedImage(pecanprep4); handleShow("") }} height='auto' className="center p-2" />
            </Grid>
            <Grid md={8} lg={8} sm={6} xs={12} className="self-center">
              <Typography
                component="h2"
                variant="h5"
                color="text.primary"
                gutterBottom
              >
                ML Feature Engineering
              </Typography>
              <p>
              PecanPrep provides ML feature engineering to empower data scientists to focus more on creating and testing AI models instead of spending time on data cleansing and feature engineering. PecanPrep provides basic feature engineering off the shelf that can be used to achieve a better signal-to-noise ratio.
              </p>
            </Grid>

            {/* </Grid> */}
          </Grid>
        </Container>
      </Box>
      <hr />
      <Box className="py-8 mb-4">
        <Container disableGutters maxWidth="sm" component="main" sx={{ pb: 6 }}>
          <Typography
            component="h1"
            variant="h2"
            align="center"
            color="text.primary"
            gutterBottom
          >
            PecanPrep Features
          </Typography>
          <Typography variant="h5" align="center" color="text.secondary" component="p">
            Basic, Professional, and Enterprise editions.
          </Typography>
        </Container>
        <Container component="main">
        <Grid container spacing={2} >
          {/* <Grid container spacing={0} xs={12} className="px-52" > */}
            <Grid md={6} lg={6} sm={6} xs={12} className="pb-8 pr-8 pl-2">
              <Typography
                component="h2"
                variant="h5"
                color="text.primary"
                gutterBottom
              >
                Interactive Processing
              </Typography>
              {/* <p>
                <span className="font-semibold">Wizard for data processing</span> to cleanse and transform the data with ease by non-developer community.
              </p> */}
              <p>
                <span className="font-semibold">Wizard for data processing:</span>  PecanPrep provides a guided wizard for easy data cleansing and transformation, which can be used by non-developer community.
              </p>
              <p>
                <span className="font-semibold">Data visualization:</span>  Relevant distribution charts are presented to the user, allowing them to visualize the data with various strategy applications.
              </p>
              <p>
                <span className="font-semibold">Statistical strategies:</span>  Users can choose UI options to apply statistical strategies to the data.
              </p>
              <p>
                <span className="font-semibold">Cloud data support:</span>  PecanPrep supports cloud data sources and on-premises data upload.
              </p>
            </Grid>
            <Grid md={6} lg={6} sm={6} xs={12} className="pb-8 pl-8">
              <Typography
                component="h2"
                variant="h5"
                color="text.primary"
                gutterBottom
              >
                EDA Reports
              </Typography>
            
              <p>
                <span className="font-semibold">Collaborate with Co-Workers: </span> Download and share reports to collaborate on data with team members.
              </p>
              <p>
                <span className="font-semibold">Data Visualization:</span> Reports include PDF format with data visualization charts, comparing the data before and after transformations are applied.
              </p>
              <p>
                <span className="font-semibold">Easy Management: </span> Manage and trigger data processing runs through an easy-to-use web interface.
              </p>
              <p>
                <span className="font-semibold">Detailed Data Distribution:</span> Reports include box plots, violin plots, and histograms to provide a thorough understanding of data distribution.
              </p>
              
            </Grid>
            <Grid md={6} lg={6} sm={6} xs={12} className="pb-8 pr-8 pl-2">
              <Typography
                component="h2"
                variant="h5"
                color="text.primary"
                gutterBottom
              >
                Statistical Analysis
              </Typography>
              <p>
                <span className="font-semibold">Outliers Detection Strategies:</span> PecanPrep supports various strategies to detect outliers, including Standard Deviation, Z-Score, Quantile Bucketing, and Fixed Limits.
              </p>
              <p>
                <span className="font-semibold">Auto Generated Metrics: </span> Users can get an overview of their data with auto-generated metrics such as records count, data sizes, feature counts, mean, median, mode, and more.
              </p>
              <p>
                <span className="font-semibold">Feature Distribution: </span> PecanPrep provides a detailed feature distribution analysis including null percentages, minimum and maximum data range, frequent values, and more.
              </p>
              <p>
                <span className="font-semibold">Univariate and Multivariate Analysis: </span> Users can perform univariate and multivariate analysis on all data types including numerical, categorical, and datetime for better insights.
              </p>
            </Grid>
            <Grid md={6} lg={6} sm={6} xs={12} className="pl-8">
              <Typography
                component="h2"
                variant="h5"
                color="text.primary"
                gutterBottom
              >
                Feature Engineering
              </Typography>
              <p>
                <span className="font-semibold">Feature Imputation & Splitting: </span> allows users to fill missing values in features and split features into multiple parts.
              </p>
              <br/>
              <p>
                <span className="font-semibold">Normalization & Bucketing strategies: </span>  enable easy transformation of numerical data for machine learning models.
              </p>
              <br/>
              <p>
                <span className="font-semibold">One Hot Encoding and Sparse Representation:</span> enable effective handling of categorical features in machine learning models.
              </p>
              <br/>
              <p>
                <span className="font-semibold">Feature Extraction Methods for time fields: </span> capture seasonality effects in time-based data.
              </p>
            </Grid>
          </Grid>
        {/* </Grid> */}
        </Container>
      </Box>

    </div >
  );
}


export default Home;